module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\n\n<div class=\"swh-save-origin-archives-form swh-save-origin-artifact-form form-row\">\n  <div class=\"form-group col-md-7\">\n    <label for=\"swh-input-artifact-url-")
    ; __append(escapeFn( formId ))
    ; __append("\">Artifact url</label>\n    <input type=\"text\" class=\"form-control\" id=\"swh-input-artifact-url-")
    ; __append(escapeFn( formId ))
    ; __append("\" required>\n    <div class=\"invalid-feedback\">The artifact url is mandatory</div>\n  </div>\n  <div class=\"form-group col-md-2\">\n    <label for=\"swh-input-artifact-version-")
    ; __append(escapeFn( formId ))
    ; __append("\">Artifact version</label>\n    <input type=\"text\" class=\"form-control\" id=\"swh-input-artifact-version-")
    ; __append(escapeFn( formId ))
    ; __append("\" required>\n    <div class=\"invalid-feedback\">The artifact version is mandatory</div>\n  </div>\n  <div class=\"col-md-2\">\n    ")
    ;  if (deletableRow) { 
    ; __append("\n      <label for=\"swh-remove-archive-artifact-")
    ; __append(escapeFn( formId ))
    ; __append("\">&nbsp;</label>\n      <button id=\"swh-remove-archive-artifact-")
    ; __append(escapeFn( formId ))
    ; __append("\" type=\"button\" class=\"btn btn-default btn-block\" onclick=\"swh.save.deleteArtifactFormRow(event)\">\n              <i class=\"mdi mdi-file-remove mdi-fw\" aria-hidden=\"true\"></i>Remove artifact\n      </button>\n    ")
    ;  } else { 
    ; __append("\n      <label for=\"swh-add-archive-artifact\">&nbsp;</label>\n      <button id=\"swh-add-archive-artifact\" type=\"button\" class=\"btn btn-default btn-block\" onclick=\"swh.save.addArtifactFormRow()\">\n        <i class=\"mdi mdi-file-plus mdi-fw\" aria-hidden=\"true\"></i>Add artifact\n      </button>\n    ")
    ;  } 
    ; __append("\n  </div>\n</div>")
  }
  return __output;

}